module.exports = __webpack_public_path__ + "static/img/13.b34db24.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/3/sp/13.png
// module id = a58r
// module chunks = 0